<script lang="ts">
    import {Button, Fileupload, Input, Label, Modal, Select, Spinner} from "flowbite-svelte";
import EmployeeContract from "$lib/partials/employee/EmployeeContract.svelte";
    import {formDataPost, retire} from "$lib/api.js";
    import type {Contract, ContractHistory, Employee} from "$lib/types/employee";
    import {onMount} from "svelte";
    import {getDocumentTemplates} from "$lib/calls/settings";
    import wordDocumentParser from "$lib/utils/templating/wordDocumentParser";
    import {PUBLIC_API_PATH} from "$env/static/public";
    import dayjs from "dayjs";
    import {getUnits} from "$lib/calls/unit";
    import {matchContractVariables} from "$lib/utils/templating/contractVariables";
    import {templateDocuments} from "$lib/stores/templateDocuments";
    import {allUnits} from "$lib/stores/unit";
    import {mailTemplates} from "$lib/stores/mailTemplates";
    import type {EmailTemplate} from "$lib/types/EmailTemplate";
    import parseHandlebars, {findUnmatchedVariables} from "$lib/utils/templating/parseHandlebars";
    import EmailTemplateEditor from "$lib/components/EmailTemplateEditor.svelte";
    import {sendEmailTemplate} from "$lib/calls/mail";
    import {storeEmployeeImage} from "$lib/calls/files";
    import {EnvelopeSolid, PenSolid} from "flowbite-svelte-icons";
    import ModalHeader from "$lib/components/ui/ModalHeader.svelte";
    import ModalFooter from "$lib/components/ui/ModalFooter.svelte";

    export let open: boolean = false;
    export let contract: Contract;

    export let externally: boolean = false;

    export let employee: Employee;

    let retireData:{endDate: string|null, files: FileList|undefined} = {
        endDate: dayjs().add(1, 'month').set('date', 1).subtract(1, 'day').format('YYYY-MM-DD'),
        files: undefined
    }
    let previewForm: HTMLFormElement;

    let history: ContractHistory|null;

    let contractTemplates:any[] = [];
    let units:any[] = [];
    let preview: Blob | null;
    let mail: EmailTemplate|null = null;
    let loading = false;
    const retireContract = async () => {
        loading = true
        if(retireData.files && retireData.files.length > 0){
            await storeEmployeeImage(retireData.files[0], 'contract-document', employee.uuid, null)
        }
        const template = contractTemplates.find(x => x.contractType === 'termination')
        const variables = matchContractVariables({
                ...employee,
                unit: units.find((u: any) => u.id === employee.unitId)},
            contract,
            {...contract.currentHistory, endDate: {value:retireData.endDate}},
            {}, {})
        if(!template) {
            alert('Fehlende Vorlage')
        } else {
            preview = await wordDocumentParser(PUBLIC_API_PATH + '/template-document/' + template.id + '/binary', variables)
        }

        history = await formDataPost(`/employee/${employee.uuid}/contract/${contract.id}/retire`, {
            endDate: retireData.endDate,
            external: externally,
            file: preview
        })
        mail = $mailTemplates.find(x => x.level === 'retiring' )
        // window.location.reload();
        loading = false
    }
    const sendEmail = async () => {
        loading = true
        await sendEmailTemplate(mail?.id, {
            fromEmail: 'legal@recrew.de',
            fromName: 'REcrew Legal',
            subject: 'REcrew_Vertragsauflösung_zwischen_' + employee.name + ' und REcrew GmbH',
            entityId: employee.id,
            content: mail.content.replace(/<% body %>/g, ''),
            toEmail: employee.email,
            toName: employee.name,
            variables: findUnmatchedVariables(mail.content)
        })
        loading = false
        location.reload(true);
    }
    const abort = async () => {
        loading = true
        if(history){
            await retire(`/employee/${employee.uuid}/contract/${contract.id}/history/${history.id}?silent=true`)
        }

        history = null
        preview = null;
        loading = false
    }
onMount(async () => {
    contractTemplates = $templateDocuments;
    if($templateDocuments.length === 0){
        contractTemplates = await getDocumentTemplates()
        $templateDocuments = contractTemplates
    }
    units = $allUnits;
    if($allUnits.length === 0){
        units = await getUnits()
        $allUnits = units
    }
    // history = contract.currentHistory
})
</script>

<Modal  size="lg" title="Vertrag auflösen" bind:open>
    <svelte:fragment slot="header">
        <ModalHeader>Vertrag auflösen</ModalHeader>
    </svelte:fragment>
    {#if !history}
        <p>Vertrag auflösen?</p>
        <form bind:this={previewForm} class="space-y-3" on:submit|preventDefault={retireContract}>
            <Label class="space-y-2">
                <span>Zum</span>
                <Input type="date" required bind:value={retireData.endDate}/>
            </Label>
            {#if externally}
                <Label class="space-y-2">
                    <span>Dokument</span>
                    <Fileupload bind:files={retireData.files} required />
                </Label>
            {/if}

        </form>
    {:else}
        <p>E-Mail versenden</p>
        <form on:submit|preventDefault={sendEmail}>
            <Label class="space-y-2 mb-3">
                <span>Vorlage</span>
                <Select required bind:value={mail.id} on:change={(e) => {const id = mail.id; mail = null; setTimeout(() => {mail = $mailTemplates.find(x => x.id === id)})}} items={$mailTemplates.filter(x => x.level === 'retiring').map(x => ({...x, value: x.id}))}/>
            </Label>
            {#if mail}
                <EmailTemplateEditor  on:update={e => mail = e.detail} preview={true} template={mail} fillData={{Employee: employee, Contract: history, Input: retireData, Unit: $allUnits.find(x => x.id === employee.unitId)}} />
            {/if}

        </form>

    {/if}
    <svelte:fragment slot="footer">
        <ModalFooter disabled={loading} on:abort={() => {abort();open = false;}} showEdit={!!preview} on:edit={() => abort()}>
            <svelte:fragment slot="right">
                {#if preview}
                    <Button class="!text-decoration-none whitespace-nowrap" download="{employee.name.replaceAll(' ','_')}.docx" href={URL.createObjectURL(preview)} target="_blank" color="light">Kündigungsvorschau</Button>
                    <Button disabled={loading} on:click={() => sendEmail()} class="bg-sky-100 text-neutral-600 whitespace-nowrap"><EnvelopeSolid class="w-4 mr-2"/>Auflösung senden</Button>
                {:else}
                    <Button disabled={loading} class="bg-sky-100 text-neutral-600" on:click={() => previewForm.requestSubmit()}>{externally ? 'Kündigung einreichen' : 'Auflösen'}</Button>
                {/if}
            </svelte:fragment>
        </ModalFooter>
    </svelte:fragment>
</Modal>